import apiClient from "./apiClient";
const resource = '/inventory-stocks?location=room';
const resourceDistribution = '/inventory-stocks/distribution?'

export default {
  async getAll(params = {}) {
    return apiClient.get(`${resource}`, {params});
  },
  async create(data) {
    return apiClient.post(`${resource}`, data);
  },
  async getById(uuid) {
    return apiClient.get(`${resource}/${uuid}`);
  },
  async update(uuid, data) {
    return apiClient.put(`${resource}/${uuid}`, data);
  },
  async delete(uuid) {
    return apiClient.delete(`${resource}/${uuid}`);
  },

// For modal distirbution in room page
  async getAllDistribution({id, params = {}}) {
    return apiClient.get(`${resourceDistribution}id=${id}`, {params});
  },

  async updateDistribution(uuid, data) {
    return apiClient.put(`inventory-stocks/${uuid}?room_stock=true`, data);
  },
};